import type { ExcursionComponentProps } from "@op/puck-types";
import { LazyComponent } from "../../../utils/LazyComponent";

export const Excursion = (props: ExcursionComponentProps) => {
  return <LazyComponent<ExcursionComponentProps> name="Excursion" {...props} />;
};
